import { render, staticRenderFns } from "./earnings.vue?vue&type=template&id=31569a54&"
import script from "./earnings.vue?vue&type=script&lang=js&"
export * from "./earnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports